import I18n from 'I18n';
/**
 * (bheng): We discussed moving this into the Flow record, but since Flow
 * imports action-feature constants and records, it introduces complexities and
 * requires us to move Flow into its own module to prevent circular
 * dependencies between core and action-feature libraries.
 */
export const getFlowName = flow => {
  if (!flow) return '';
  return flow.name || I18n.text('automation-ui-flow-core.flow.noFlowName');
};
export const isFlowEmpty = flow => !flow || Object.keys(flow.actions).length === 0 && flow.enrollmentCriteria === null;
export const getIsObjectlessFlow = flow => {
  var _flow$enrolledType, _flow$enrolledType2;
  return (flow === null || flow === void 0 || (_flow$enrolledType = flow.enrolledType) === null || _flow$enrolledType === void 0 ? void 0 : _flow$enrolledType.type) === 'ARGUMENTS' || (flow === null || flow === void 0 || (_flow$enrolledType2 = flow.enrolledType) === null || _flow$enrolledType2 === void 0 ? void 0 : _flow$enrolledType2.type) === 'VOID';
};